import React from 'react';
import { ThemeProvider } from 'styled-components';
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles';
import { createTheme } from '@sierralabs/core-ui';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import lightblue from '@material-ui/core/colors/lightBlue';
const breakpoints = createBreakpoints({
    values: {
        xs: 0,
        sm: 600,
        md: 768,
        lg: 960,
        xl: 1024
    }
});
const defaultTheme = createTheme({
    breakpoints,
    palette: {
        primary: {
            main: '#1E3850'
        },
        secondary: {
            main: '#2196f3'
        },
        error: {
            main: '#CA270E'
        }
    },
    typography: {
        h2: { fontSize: 22, fontWeight: 'bold' },
        h6: { fontSize: 16 },
        body1: { fontSize: 12 }
    },
    pageTemplate: {
        background: '#f0f1f7'
    },
    props: {},
    overrides: {
        MuiCard: {
            root: {
                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08);'
            }
        },
        MuiDialogTitle: {
            root: {
                paddingBottom: 4
            }
        },
        MuiIcon: {
            root: {
                '&.material-icons': {
                    fontSize: '16px'
                }
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 36
            }
        },
        // MuiOutlinedInput: {
        //   input: {
        //     padding: '12px 14px'
        //   }
        // },
        MuiTableRow: {
            hover: {
                cursor: 'pointer'
            },
            root: {
                '&$selected, &$selected:hover': { backgroundColor: lightblue[50] }
            }
        }
    }
});
export const SiteThemeProvider = props => {
    const { children } = props;
    const theme = props.theme || defaultTheme;
    return (
    //Make sure the Material stylesheet is placed above your own
    //styles so you can overwrite them
    React.createElement(StylesProvider, null,
        React.createElement(MuiThemeProvider, { theme: theme },
            React.createElement(ThemeProvider, { theme: theme }, children))));
};
//# sourceMappingURL=SiteThemeProvider.js.map